import { useLocation, useNavigate } from "@tanstack/react-router";
import { useCallback, useMemo } from "react";
import {
    type GraphLocation,
    type GraphSearch,
    readGraphLocation,
    writeGraphLocation,
} from "../services/graphLocation";

export const useGraphLocation = () => {
    const navigate = useNavigate();
    const routerLocation = useLocation();
    const search = routerLocation.search as GraphSearch & { tab?: string };

    const location = useMemo(() => readGraphLocation(search), [search]);

    const goTo = useCallback(
        (next: GraphLocation, options?: { replace?: boolean }) => {
            navigate({
                // biome-ignore lint/suspicious/noExplicitAny: generated router types omit search params
                to: routerLocation.pathname as any,
                search: { tab: search.tab, ...writeGraphLocation(next) } as never,
                replace: options?.replace ?? false,
            });
        },
        [navigate, routerLocation.pathname, search.tab],
    );

    return { location, goTo };
};
